module.exports = __webpack_public_path__ + "assets/img/admission-banner.8fff0407.png";